import qs from 'qs';
import { PICKUP_DATA } from '../../constants/endpoints';
import { NUMBER_OF_PICKUP_DAYS } from '../../constants/pickups';
import { receivePaymentResponse } from '../stripe';

export const RECEIVE_IS_FETCHING_PICKUP_DATA = 'RECEIVE_IS_FETCHING_PICKUP_DATA';
export const RECEIVE_PICKUP_DATA_ERROR = 'RECEIVE_PICKUP_DATA_ERROR';
export const RECEIVE_PICKUP_FORM = 'RECEIVE_PICKUP_FORM';
export const RECEIVE_PICKUP_INSTRUCTIONS = 'RECEIVE_PICKUP_INSTRUCTIONS';
export const RECEIVE_TOGGLE_PICKUP_INSTRUCTIONS = 'RECEIVE_TOGGLE_PICKUP_INSTRUCTIONS';
export const RECEIVE_PICKUP_PHONE_NUMBER = 'RECEIVE_PICKUP_PHONE_NUMBER';
export const RECEIVE_PICKUP_PHONE_NUMBER_ERROR = 'RECEIVE_PICKUP_PHONE_NUMBER_ERROR';
export const RECEIVE_PICKUP_TIME_WINDOW = 'RECEIVE_PICKUP_TIME_WINDOW';

export const fetchPickupData =
  ({ service, carrier }) =>
  async (dispatch, getState) => {
    const {
      retailerSettings: { name: retailerName } = {},
      addresses: { defaultAddressKey, [defaultAddressKey]: address = {} },
      orderInfo: { currentOrderNumber },
    } = getState();

    try {
      dispatch({
        type: RECEIVE_IS_FETCHING_PICKUP_DATA,
        data: {
          isFetching: true,
        },
      });

      const response = await fetch(
        PICKUP_DATA({
          retailerName,
          params: qs.stringify({
            order_number: currentOrderNumber,
            return_carrier: carrier,
            postal_code: address.zip,
            number_of_days: NUMBER_OF_PICKUP_DAYS,
          }),
        }),
      );

      const {
        client_secret: paymentIntentSecret,
        narvar_payment_id: narvarPaymentId,
        stripe_publishable_key: publishableKey,
        pickup_slot: pickupSlot,
      } = await response.json();

      if (!pickupSlot || !pickupSlot.date) {
        throw new Error('No pickup slots');
      }

      dispatch(
        receivePaymentResponse({
          service,
          paymentIntentSecret,
          narvarPaymentId,
          publishableKey,
        }),
      );

      dispatch({
        type: RECEIVE_PICKUP_FORM,
        data: {
          service,
          options: {
            timeWindows: pickupSlot.open_all_day ? [] : pickupSlot.time_window,
          },
          form: {
            date: pickupSlot.date,
            address,
          },
        },
      });

      dispatch({
        type: RECEIVE_IS_FETCHING_PICKUP_DATA,
        data: {
          isFetching: false,
        },
      });
    } catch (error) {
      dispatch({
        type: RECEIVE_PICKUP_DATA_ERROR,
      });
    }
  };

export const receivePickupInstructions = (instructions) => ({
  type: RECEIVE_PICKUP_INSTRUCTIONS,
  data: {
    instructions,
  },
});

export const togglePickupInstructions = () => ({
  type: RECEIVE_TOGGLE_PICKUP_INSTRUCTIONS,
});

export const receivePickupPhoneNumber = (phoneNumber) => ({
  type: RECEIVE_PICKUP_PHONE_NUMBER,
  data: {
    phoneNumber,
  },
});

export const receivePickupPhoneError = (phoneNumberError) => ({
  type: RECEIVE_PICKUP_PHONE_NUMBER_ERROR,
  data: {
    phoneNumberError,
  },
});

export const receivePickupTimeWindow = (pickupTime) => ({
  type: RECEIVE_PICKUP_TIME_WINDOW,
  data: {
    pickupTime,
  },
});
